
/*

    NOT FINISHED

*/


import React, { useEffect, useState } from 'react';
import { Button, Card, Divider, Input, InputNumber, Space, Table, Tag, Typography } from 'antd';
//import { CheckCircleOutlined, DownOutlined, EditOutlined, UpOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from './Production.redux';
//import useDebounce from 'hooks/useDebounce';
import { notification } from 'antd';
import HeaderDetails from '../shared/HeaderDetails';
import HeaderItemDisplay from '../shared/HeaderItemDisplay';
import LoadingCover from 'components/LoadingCover';
import ___ from '../constants';
import sizeSorter from '../shared/sizeSorter';

const showNotes = true;

const { Title } = Typography;

const sizeFilter = (value, record) => {
    //console.log(value);
    //console.log(record);
    return record.size.indexOf(value) === 0;
};

const OrderStatusText = (r) => {
    // console.log('[ProductionModal] OrderStatusText');
    // console.log(r); // record
    const _isProductionOrderComplete = (r) => {
        if (r.fgCompletedQty >= r.fgPlannedQty) {
            return true;
        }
        return false;
    };

    if (r.isClosed === ___.TRUE) {
        return 'Closed';
    } if (r.isClosed === ___.FALSE && _isProductionOrderComplete(r)) {
        return 'Complete';
    } else if (r.openLines > 0 && r.fgCompletedQty > 0) {
        return 'Partial';
    } else if (r.issuedQty > 0) {
        return 'Partial';
    } else if (r.openLines >= 0 && r.fgCompletedQty === 0) {
        return 'Pending';
    } else if (r.issuedQty === 0) {
        return 'Pending';
    } else {
        'BAD';
    }

};

const ProductionModal = (props) => {
    const { handleClose, clearSearch } = props;

    const dispatch = useDispatch();


    const rdxCurrentEditRow = useSelector(state => state.warehouseProd.currentEditRow);
    //console.log(rdxCurrentEditRow)
    const [editRow, setEditRow] = useState(rdxCurrentEditRow);
    //console.log(editRow)

    const loading = useSelector(state => state.warehouseProd.loading);

    const detailLines = useSelector(state => state.warehouseProd.detailLines);
    const [editDetailsLines, setEditDetailLines] = useState(detailLines);
    const [hasNotesEdits, setHasNotesEdits] = useState(false);

    //console.log(detailLines)

    useEffect(() => {
        //console.log('[ProductionModal.js] rdxCurrentEditRow change');
        //console.log(rdxCurrentEditRow);
        setEditRow(rdxCurrentEditRow);
    }, [
        dispatch,
        rdxCurrentEditRow,
    ]);

    useEffect(() => {
        //console.log('[ProductionModal.js] editRow change');
        //console.log(editRow);
        //setEditDetailLines(detailLines);
    }, [
        dispatch,
        editRow,
    ]);

    useEffect(() => {
        //console.log('[ProductionModal.js] detailLines change');
        //console.log(detailLines);
        setEditDetailLines(detailLines);
    }, [
        dispatch,
        detailLines,
    ]);

    /**
     * PRO: Handles the change in quantity input.
     *
     * PRO: Updates the `editRow` state with the new finishedQty.
     *
     * @param {*} e - event / new numerical value.
     */
    const onChangeQty = (e) => {
        // console.log('onChangeQty');
        // console.log(e);
        setEditRow({
            ...editRow,
            finishedQty: e,
        });
    };

    // const handleChangeNotes = (e) => {
    //     console.log(e.target.value);
    //     setEditRow({
    //         ...editRow,
    //         notes: e.target.value.toString(),
    //     });
    // };

    const handleChangeNotes = (e, f) => {
        console.log('handleChangeNotes');
        console.log(e.target.value)
        console.log(f)
        //console.log(e.target.value);
        setEditRow({
            ...editRow,
            [f]: e.target.value.toString(),
        });
        setHasNotesEdits(true);

    };
    const popSuccess = () => {
        notification.success({
            placement: 'bottom',
            message: 'Quantity Received Successfully',
            duration: 5,
        });
        setTimeout(() => handleClose(), 500);
        setTimeout(() => clearSearch(), 500);
    };

    // const popFailure = () => {
    //     notification.error({
    //         placement: 'bottom',
    //         message: 'Error',
    //         duration: 5,
    //     });
    // };

    const popFailureClosed = () => {
        notification.error({
            placement: 'bottom',
            message: 'Error: Cannot write to closed document',
            duration: 5,
        });
    };

    const handleSubmitFG = () => {
        //console.log('handleSubmitFG');
        if (editRow.isClosed === ___.TRUE) {
            popFailureClosed();
            return null;
        } else {
            dispatch(actions.writeProductionOrder(editRow, popSuccess));
        }
    };

    const handleCancel = () => {
        //console.log('[ProductionModal.js handleCancel');
        handleClose();
    };

    const handleSaveNotes = (editRow) => {
        console.log('[Production] handleSaveNotes');
        dispatch(actions.writeSalesOrderNotes(editRow));
        setHasNotesEdits(false);
    };


    return (
        <>
            <Title level={3}>Finishing Details</Title>
            {
                editRow &&
                <HeaderDetails>
                    <>
                        <Card size="large"/* title="Finishing Details" */>
                            <Space direction="vertical" className="">
                                <HeaderItemDisplay
                                    text={editRow.docNum}
                                    label={'PRO#'}
                                />
                                <HeaderItemDisplay
                                    text={editRow.origSO}
                                    label={'Orig. SO#'}
                                />
                                <HeaderItemDisplay
                                    text={editRow.productName}
                                    label={'Prod. Name'}
                                />
                                <HeaderItemDisplay
                                    text={editRow.productItemCode}
                                    label={'Item Code'}
                                />
                                <HeaderItemDisplay
                                    text={editRow.ProductionModal}
                                    label={'Prod Model'}
                                />
                            </Space>
                        </Card>

                        <Card size="large" title="Customer">
                            <Space direction="vertical" className="">
                                <HeaderItemDisplay
                                    text={editRow.bpName}
                                    label={'BP'}
                                />
                                <HeaderItemDisplay
                                    text={editRow.project3 === '' ? ___.NOT_AVAILABLE : (editRow.project3 + ' ' + editRow.project2 + ' ' + editRow.project)}
                                    label={'Project'}
                                />
                            </Space>
                        </Card>
                        <Card size="large" title="Finishing">
                            <Space direction="vertical" className="">
                                <HeaderItemDisplay
                                    text={OrderStatusText(editRow)} // proStatus
                                    label={'Status'}
                                />
                            </Space>
                        </Card>
                        <Card size="large" title="Finished Quantity">
                            <Space direction="vertical" className="">
                                {/* <HeaderItemDisplay
                                    text={editRow.finishedQty}
                                    label={'PRO: finishedQty'}
                                /> */}
                                <InputNumber
                                    disabled={editRow.isClosed === ___.TRUE}
                                    onChange={(e) => onChangeQty(e)}
                                    min={0}
                                    //max={1000}
                                    value={editRow ? editRow.finishedQty : 0}
                                    defaultValue={0} />
                            </Space>
                        </Card>
                    </>
                </HeaderDetails>
            }


            {/* {(showNotes && editRow) &&
                <>
                    <Title level={3}>Notes</Title>
                    <Input.TextArea
                        placeholder={editRow && editRow.notes
                            ? editRow.notes
                            : '...'}
                        name="production_notes"
                        value={editRow.notes}
                        onChange={(e) => handleChangeNotes(e, 'notes')}
                        maxLength={254}
                        autoSize={{ minRows: 2, maxRows: 6 }}
                    />

                </>
            } */}

            {(showNotes && editRow) &&
                <>
                    <Divider />
                    <Title level={3}>Order Notes</Title>
                    <Input.TextArea
                        placeholder={editRow && editRow.orderNotes
                            ? editRow.orderNotes
                            : '...'}
                        name="order_notes"
                        value={editRow.orderNotes}
                        onChange={(e) => handleChangeNotes(e, 'orderNotes')}
                        maxLength={254}
                        autoSize={{ minRows: 2, maxRows: 6 }}
                    />
                    <Title level={3}>Internal Notes</Title>
                    <Input.TextArea
                        placeholder={editRow && editRow.internalNotes
                            ? editRow.internalNotes
                            : '...'}
                        name="internal_notes"
                        value={editRow.internalNotes}
                        onChange={(e) => handleChangeNotes(e, 'internalNotes')}
                        maxLength={254}
                        autoSize={{ minRows: 2, maxRows: 6 }}
                    />

                    <>
                        <Button disabled={!hasNotesEdits} onClick={() => handleSaveNotes(editRow)}>Save</Button>
                        {/* <Button onClick={handleResetNotes}>Reset</Button> */}
                    </>

                </>
            }

            <Divider />
            <Title level={3}>Production</Title>

            {/* {
                editDetailsLines &&
                <>
                    <ProductionModalTable
                        lines={editDetailsLines}
                        editRow={editRow}
                        onChangeQty={onChangeQty}
                        handleSubmitFG={handleSubmitFG}
                        handleCancel={handleCancel}
                    />
                </>
            } */}

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                    type="default"
                    onClick={() => handleCancel()}
                    size="large"
                >
                    Cancel
                </Button>
                <Button
                    type="primary"
                    onClick={() => handleSubmitFG()}
                    size="large"
                >
                    Submit
                </Button>
            </div>

            {loading && <LoadingCover />}

        </>
    );
};


const ProductionModalTable = (props) => {
    //console.log(props)
    const { lines, editRow, handleCancel, handleSubmitFG, onChangeQty } = props;
    //console.log(lines)

    const columns = [
        {
            title: 'ItemCode',
            dataIndex: 'itemCode',          // OWOR.ItemCode
            key: 'itemCode',
            render: (_, record) =>
            (
                <>
                    {editRow ? editRow.itemCode : null}
                </>
            ),
        },
        // {
        //     title: 'productItemCode', 	    // OWOR.ItemCode
        //     dataIndex: 'productItemCode',
        //     key: 'productItemCode',
        // },
        {
            title: 'componentItemCode', 	    // WOR1.ItemCode
            dataIndex: 'componentItemCode',
            key: 'componentItemCode',
        },
        {
            title: 'productName',           // OWOR.ProdName
            dataIndex: 'productName',
            key: 'productName',
        },
        {
            title: 'size',
            dataIndex: 'size',
            key: 'size',
            // render: (_, record) =>
            // (
            //     <Tag color="success">{record.size}</Tag>
            // ),
            render: (_, record) =>
            (
                <Tag color="success">{record.size
                    ? record.size
                    : 'Other'}</Tag>
            ),
            filters: [
                {
                    text: 'XS',
                    //value: 'sz-xs',
                    value: 'XS',
                },
                {
                    text: 'SM',
                    //value: 'sz-sm',
                    value: 'SM',
                },
                {
                    text: 'MD',
                    //value: 'sz-md',
                    value: 'MD',
                },
                {
                    text: 'LG',
                    //value: 'sz-lg',
                    value: 'LG',
                },
                {
                    text: 'XL',
                    //value: 'sz-1x',
                    value: 'XL',
                },
                {
                    text: 'XXL',
                    //value: 'sz-2x',
                    value: 'XXL',
                },
                {
                    text: 'XXXL',
                    //value: 'sz-3x',
                    value: 'XXXL',
                },
                {
                    text: 'Other',
                    value: 'other',
                    children: [
                        {
                            text: 'Hats',
                            value: 'hats',
                        },
                        {
                            text: 'Patches',
                            value: 'patches',
                        },
                    ],
                },
            ],
            onFilter: sizeFilter,
            sorter: sizeSorter,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
            title: 'Requested',
            dataIndex: 'plannedQty',
            key: 'plannedQty',
            sorter: (a, b) => a.plannedQty - b.plannedQty,

        },
        {
            title: 'Received',
            dataIndex: 'completeQty',
            key: 'completeQty',
            sorter: (a, b) => a.completeQty - b.completeQty,

        },
        // {
        // TODO_UNUSED disabled while we work on logic to return unused component to inventory 
        //     title: 'Qty to Receive',
        //     dataIndex: 'finishedQty',
        //     key: 'finishedQty',
        //     render: (_, record) =>
        //     (
        //         <>
        //             {
        //                 record.IssueType === ___.PRODUCTION_BACKFLUSH
        //                     ?
        //                     <Tag color="error">Backflush</Tag>
        //                     :
        //                     <InputNumber
        //                         disabled={record.isClosed === ___.TRUE}
        //                         onChange={(e) => onChangeQty(e)}
        //                         min={0}
        //                         //max={1000}
        //                         value={record.finishedQty}
        //                         defaultValue={0} />
        //             }
        //         </>
        //     ),
        // },
        {
            title: '%',
            width: 100,
            align: 'center',
            dataIndex: 'percent-of_line',
            render: (_, record) =>
            (
                <Tag color="grey">
                    {/* {
                        (((record.completeQty) / record.plannedQty) * 100).toFixed(0) + '%'
                    } */}
                    {
                        record.completeQty && record.plannedQty !== 0
                            ? `${((record.completeQty / record.plannedQty) * 100).toFixed(0)}%`
                            : 'N/A'
                    }
                </Tag> // TODO INF
            ),
        },
        // {
        //     title: 'Status',
        //     dataIndex: 'lineStatus',
        //     key: 'lineStatus',
        //     render: (_, record) =>
        //     (
        //         record.lineStatus !== 'X'
        //             ? <Tag color="success">{record.lineStatus}</Tag>
        //             : <Tag color="warning">{record.lineStatus}</Tag>
        //     ),
        // },
    ];



    return (
        <>
            <Table
                dataSource={lines}
                columns={columns}
                key={'rcv-item-table'}
                rowKey={'key'}
            />
            {/* <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                    type="default"
                    onClick={() => handleCancel()}
                    size="large"
                >
                    Cancel
                </Button>
                <Button
                    type="primary"
                    onClick={() => handleSubmitFG()}
                    size="large"
                >
                    Submit
                </Button>
            </div> */}
        </>
    );
};


export default ProductionModal;
